import { buildQueryParams, requestBuilder } from '../../../http/RequestBuilder';

interface SearchTransactionsParams {
    membershipId: string;
    q: string;
    limit?: number;
    accountId?: string;
    startDate?: string;
    endDate?: string;
}

export interface TransactionSearchResult {
    _id: string;
    transactionId?: string;
    accountId: string; // Quiltt account ID (e.g., "acct_...")
    localAccountId?: string; // Internal account ID that matches AccountSummary.id
    amount: number;
    description: string;
    transactionDate: string;
    type: 'debit' | 'credit';
    llmCategory?: string;
    llmVendor?: string;
    rawDescription?: string | null;
    createdAt: string;
    updatedAt: string;
    membershipId: string;
    userId: string;
    aggregatorData?: {
        aggregatorName?: string;
        accountId?: string;
    };
}

export interface TransactionSearchResponse {
    results: TransactionSearchResult[];
    count: number;
    query: string;
    membershipId: string;
}

export const useSearchTransactions = requestBuilder.query<
    TransactionSearchResponse,
    SearchTransactionsParams
>({
    endpoint: (params) => {
        const queryParams: Record<string, string> = {
            membershipId: params.membershipId,
            q: params.q,
        };

        if (params.limit != null) {
            queryParams.limit = params.limit.toString();
        }
        if (params.accountId != null && params.accountId !== '') {
            queryParams.accountId = params.accountId;
        }
        if (params.startDate != null && params.startDate !== '') {
            queryParams.startDate = params.startDate;
        }
        if (params.endDate != null && params.endDate !== '') {
            queryParams.endDate = params.endDate;
        }

        return `/api/admin/holistic/transactions/search${buildQueryParams(queryParams)}`;
    },
    queryKey: (params) =>
        `searchTransactions/${params.membershipId}/${params.q}/${params.limit ?? 'default'}/${params.accountId ?? 'all'}/${params.startDate ?? 'none'}/${params.endDate ?? 'none'}`,
});
